import React, { useEffect, useState } from 'react';
import useTranslate from '../../../../Hooks/useTranslate';
import useAPI from '../../../../api';
import { useSetAtom } from 'jotai';
import {
  Fade,
  Paper,
  Box,
  Typography,
  IconButton,
  Tooltip,
  Stack,
  Divider,
} from '@mui/material';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import SchemaRoundedIcon from '@mui/icons-material/SchemaRounded';
import { openSnackbarAdviseAtom } from '../../../../Atoms';
import SectionPage from '../../../../Components/Paper/SectionPage';
import Chip from '../../../../Components/Chip';
import { ROUTE_ICONS } from '../../../../Router/routes';
import { FullSizeCenteredFlexBox } from '../../../../Components/FlexBox';
import capitalize from '../../../../Helpers/StringsFormatting/capitalize';
import ConfigurationDialog from './Components/ConfigurationDialog';
import BackButton from '../BackButton';
import SimulationsHistory from '../SimulationsHistory';

const StagedImports = function StagedImports({
  show = false,
  close = () => {},
  onSave,
}) {
  const translate = useTranslate();
  const API = useAPI();
  const openSnackbar = useSetAtom(openSnackbarAdviseAtom);

  const [stagedBranches, setStagedBranches] = useState([]);
  const [configurationDialog, setConfigurationDialog] = useState(false);
  const [simulationsPage, setSimulationsPage] = useState(null);

  const loadStagedImports = () => {
    API.getStagedBranches(
      (res) => {
        setStagedBranches(res);
      },
      () => {
        setStagedBranches([]);
      }
    );
  };

  useEffect(() => {
    if (!show) return;

    loadStagedImports();
  }, [show]);

  const handleOpenConfigurationDialog = (data) => {
    setConfigurationDialog(data);
  };
  const handleCloseConfigurationDialog = () => {
    setConfigurationDialog(false);
  };

  const handleShowSimulationsHistory = (data) => {
    setSimulationsPage(data);
  };

  const handleRunWaveSimulation = ({ branchId, schema }) => {
    API.runWaveSimulation(
      branchId,
      schema,
      (res) => {
        console.log(res);
      },
      (err) => {
        console.error(err);
      }
    );
  };

  return (
    <>
      <SimulationsHistory
        show={Boolean(simulationsPage)}
        data={simulationsPage}
        tabs={simulationsPage?.details?.map(({ sectionId, name }) => ({
          id: sectionId,
          name,
        }))}
        close={() => setSimulationsPage(null)}
        loadStagedImports={loadStagedImports}
      />
      <Fade in={show && !simulationsPage} unmountOnExit>
        <div
          style={{
            display: show ? 'block' : 'none',
            height: '100%',
          }}
        >
          <SectionPage
            hideExportExcel
            hideSorting
            hideFilters
            hideSearchBar
            sectionName="STAGED_IMPORTS"
            customClick={handleShowSimulationsHistory}
            singlePageList={stagedBranches}
            columns={[
              {
                id: 'branchDescription',
                noCaption: true,
                size: 3,
              },
              {
                id: 'details',
                noCaption: true,
                formatCallback: (details) => (
                  <FullSizeCenteredFlexBox
                    gap="16px"
                    flexWrap="wrap"
                    justifyContent="flex-start"
                  >
                    {details.map(({ name, count }) => {
                      const Icon = ROUTE_ICONS[name?.toUpperCase()];
                      return (
                        <Chip
                          variant="outlined"
                          label={`${capitalize(name?.toLowerCase())} ${count}`}
                          icon={Icon ? <Icon color="inherit" /> : null}
                          value={name?.toLowerCase()}
                          color="#1D5B9D"
                        />
                      );
                    })}
                  </FullSizeCenteredFlexBox>
                ),
              },
            ]}
            customStatusChipCallback={({ data }) => (
              <Chip
                variant="outlined"
                fontSize="1rem"
                label={`${translate('TOTAL')}: ${data?.count}`}
                width="100%"
                color="#1D5B9D"
              />
            )}
            sectionSubName={<BackButton label="WAVE" onClick={close} />}
          />
        </div>
      </Fade>
    </>
  );
};

export default StagedImports;
